"use strict"
exports.__esModule = true;
exports.ScreenIconConfig = {
  name: 'ScreenIcon',
  height: 1024,
  width: 1088,
  svgPath: 'M1088,832 L1088,64 L0,64 L0,832 L448,832 L448,896 L256,896 L256,960 L832,960 L832,896 L640,896 L640,832 L1088,832 Z M128,704 L128,192 L960,192 L960,704 L128,704 Z',
  yOffset: 0,
  xOffset: 0,
};
exports.ScreenIcon = require('../createIcon').createIcon(exports.ScreenIconConfig);
exports["default"] = exports.ScreenIcon;